import { Action } from '@/_core/fluxstore/types';
import { ConfirmState, ExtraButton, ConfirmDismissReason } from '../types';

import { useConfirmModule } from '..';
const { registerReducer } = useConfirmModule();

export class OpenConfirm extends Action<ConfirmState> {
    public static ACTION_TYPE = 'AppConfirm::OpenConfirm';

    public constructor(public props: OpenConfirmProps) {
        super(OpenConfirm.ACTION_TYPE);
    }
}

export interface OpenConfirmProps {
    ownerId?: string;
    onDismiss?: (reason: ConfirmDismissReason) => void;
    acceptDisabled?: () => boolean;
    defaultButton?: 'accept' | number;
    distinguishFocusedButton?: boolean;
    title: string;
    message: string;

    attach?: string | boolean;
    acceptBtnText?: string;
    cancelBtnText?: string;
    isHideCancelBtn?: boolean;
    acceptBtnColor?: string;
    acceptBtnClasses?: string[];
    extraButtons?: ExtraButton[];
    extraHtmlAfterButtons?: string;
    acceptSideButtons?: ExtraButton[];
    acceptFn?: () => void;
    cancelFn?: () => void;
    width?: number;
    contentClasses?: string[];
}

let nextInstanceId = 0;

// eslint-disable-next-line
const reducer = (state: ConfirmState, action: OpenConfirm): void => {
    const superseded = state.isOpen ? state.onDismiss : undefined;
    state.instanceId = ++nextInstanceId;
    state.ownerId = action.props.ownerId;
    state.onDismiss = action.props.onDismiss;
    state.acceptDisabled = action.props.acceptDisabled;
    state.defaultButton = action.props.defaultButton ?? 'accept';
    state.distinguishFocusedButton = action.props.distinguishFocusedButton ?? false;
    state.isOpen = true;

    state.message = action.props.message;
    state.attach = action.props.attach ? action.props.attach : false;

    state.title = action.props.title;
    state.width = action.props.width ? action.props.width : 400;

    state.contentClasses = action.props.contentClasses ? action.props.contentClasses : [];

    state.acceptFn = action.props.acceptFn ? action.props.acceptFn : null;
    state.cancelFn = action.props.cancelFn ? action.props.cancelFn : null;

    state.acceptBtnText = action.props.acceptBtnText ? action.props.acceptBtnText : 'Yes';
    state.cancelBtnText = action.props.cancelBtnText ? action.props.cancelBtnText : 'Cancel';

    state.isHideCancelBtn = action.props.isHideCancelBtn ? action.props.isHideCancelBtn : false;

    state.acceptBtnColor = action.props.acceptBtnColor ? action.props.acceptBtnColor : 'primary';
    state.acceptBtnClasses = action.props.acceptBtnClasses ? action.props.acceptBtnClasses : null;

    state.extraButtons = action.props.extraButtons ? [...action.props.extraButtons] : [];

    state.extraHtmlAfterButtons = action.props.extraHtmlAfterButtons;
    state.acceptSideButtons = action.props.acceptSideButtons ? [...action.props.acceptSideButtons] : [];
    // Publish the new dialog first: settling an older owner cannot close it.
    if (superseded) superseded('superseded');
};

//@ts-ignore
registerReducer(OpenConfirm.ACTION_TYPE, reducer);
